import React from 'react';
import Button from '../../../../muiComponents/Button';
import useTranslate from '../../../../customHooks/useTranslate';
import { useNotification } from '../../../../contexts/NotificationsContext';
import { cancelRequestToMember } from '../../../../services/zinantis/members/zinantisMemberListServices';
import { FeedbackMessages } from '../../../../utils/commonVariables/messages';

interface ICancelRequestButtonProps {
    onChangeLoading: (isLoading: boolean) => void;
    onRequestSuccess: () => Promise<void>;
    idRequest: number | string;
}

const CancelRequestButton = (props: ICancelRequestButtonProps) => {
    const { onChangeLoading, onRequestSuccess, idRequest } = props;
    const { setErrorMessage, setSuccessMessage } = useNotification();

    const translate = useTranslate();

    const handleRequestConnection = async () => {
        try {
            onChangeLoading(true);
            const { data } = await cancelRequestToMember(idRequest);
            if (data.Success && data.StatusCode === 200) {
                await onRequestSuccess();
                setSuccessMessage(
                    FeedbackMessages.SUCCESSFUL_CANCEL_REQUEST_SENT
                );
            } else {
                setErrorMessage(FeedbackMessages.ERROR_FETCHING);
            }
        } catch (error) {
            console.log({ error });
            setErrorMessage(FeedbackMessages.ERROR_FETCHING);
        } finally {
            onChangeLoading(false);
        }
    };

    return (
        <Button
            startIcon='LinkOff'
            variant='contained'
            className='delete-button white-space-nowrap'
            style={{ height: '30px' }}
            onClick={handleRequestConnection}
        >
            {translate('cancel_request')}
        </Button>
    );
};

export default CancelRequestButton;
